module.exports = __webpack_public_path__ + "img/item_bookCover_17.dfcfc8b4.jpeg";